import DDados from '../address.ddados';
import api from '@common/components/address/service/address.service';
import addressActions from '@common/components/address/store/address.actions';
import addressSelectors from '@common/components/address/store/address.selectors';
import { connect } from '@common/components/base.component';
import DDadosItem from '@common/components/ddados/ddados.item';
import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';
import { Col, Row } from 'react-bootstrap';
import AddressLookup from './address.lookup';
import focusHelper from '@common/helpers/focus.helper';
import _ from 'lodash';
import sessionUtil from '@common/helpers/sessionStorage.utils';
import textUtil from '@common/helpers/text.utils';
import * as commonActionType from '@common/store/common/common.actionsType';

class AddressMultiple extends Component {
  constructor(props) {
    super(props, DDados);
    this.isExterno = sessionUtil.getItem('isExterno');

    this.state = {
      tipoLogradouro: [],
      invalidCEP: false,
    };

    autoBind(this);
  }

  async componentDidMount() {
    PubSub.subscribe(commonActionType.RESET, this.clear.bind(this));

    if (this.state.tipoLogradouro && this.state.tipoLogradouro.length <= 0) {
      var tipoLogradouroResult = await api.tipoLogradouro();

      this.setState({ tipoLogradouro: tipoLogradouroResult.data });
    }

    if (this.props.filterCepBySede) {
      const responseSede = await api.getCepSede();

      this.cepSede = responseSede.data;
    }
  }

  static getDerivedStateFromProps(props, currentState) {
    const { state } = props;

    if (state) {
      if (JSON.stringify(state) != JSON.stringify(currentState.state)) {
        return {
          ...state,
          Cep: textUtil.maskCep(state.Cep),
          UF: state.Uf || state.UF,
          state,
        };
      }
    }
    return null;
  }

  async onChangeCep(value) {
    const { disableAll, filterCepBySede, name, exceptionFields, dontDisableFieldsOnInvalidCep } = this.props;

    var wasCatch = false;

    if (value && value != this.state.Cep) {
      this.setState({ invalidCEP: false });

      if (_.isObject(value)) {
        let newAddress = {
          ...value,
          IdCep: undefined,
          Cep: textUtil.maskCep(value.CEP),
          UF: value.Uf || value.UF,
        };

        this.setState({ ...newAddress });

        this.callPropsChange(newAddress);
      } else {
        try {
          const cep = value.replace(/[_-]/gi, '');

          if (!disableAll && cep.length == 8) {
            const result = await api.getByCep({ data: cep, filterCepBySede: filterCepBySede });
            const { data } = result;

            this.setState({
              UF: data.Uf,
              Cidade: data.Cidade,
              Logradouro: data.Logradouro,
              Tipo: data.Tipo,
              Bairro: data.Bairro,
              Cep: textUtil.maskCep(value),
              Numero: undefined,
              Complemento: undefined,
              ComplementoNumero: undefined,
            });
          } else {
            await this.clear(exceptionFields);

            this.setState({
              Cep: value,
            });
          }
        } catch {
          wasCatch = true;
          await this.clear(exceptionFields);

          this.setState({
            Cep: value,
            invalidCEP: true,
          });
        } finally {
          this.callPropsChange();

          if (wasCatch && dontDisableFieldsOnInvalidCep)
            this.setState({
              invalidCEP: false,
              Cep: undefined,
            });
        }
      }
    }

    if (this.isCepUnico()) focusHelper.focus(`${name}.Bairro`);
  }

  callPropsChange(newAddress) {
    const { onChange } = this.props;
    const { UF, Cidade, Logradouro, Tipo, Bairro, Cep, Complemento, ComplementoNumero, Numero } =
      newAddress || this.state;

    onChange &&
      onChange({
        UF,
        Cidade,
        Logradouro,
        Tipo,
        Bairro,
        Cep: this.hasNumber(Cep) ? Cep : undefined,
        Complemento,
        Numero,
        ComplementoNumero,
      });
  }

  hasNumber(string) {
    return /\d/.test(string);
  }

  async clear(exceptionFields) {
    const resetState = {
      UF: undefined,
      Cidade: undefined,
      Logradouro: undefined,
      Tipo: undefined,
      Bairro: undefined,
      Numero: undefined,
      Complemento: undefined,
      ComplementoNumero: undefined,
    };

    if (exceptionFields?.length) {
      exceptionFields.forEach((campo) => {
        delete resetState[campo];
      });
    }

    if (!this.props.shouldNotClean) this.setState(resetState);
  }

  isDisabledField(field) {
    const { Cep, invalidCEP } = this.state;
    const { disabledFields, blockFieldCepInvalid } = this.props;

    if (field === 'Cep') return blockFieldCepInvalid;

    if (this.props.disableAll || invalidCEP) return true;

    if (disabledFields) {
      if (this.validateFieldCepUnico(field)) return this.state[field] && disabledFields[field];
      else return disabledFields[field];
    }

    if (this.validateFieldCepUnico(field)) return false;

    const value = this.state[field];
    if (Cep && !Cep.includes('_') && (!value || (value.trim && !value.trim()))) return false;

    return DDados.Campos[field].Desabilitado;
  }

  validateFieldCepUnico(field) {
    return (field === 'Bairro' || field === 'Tipo' || field === 'Logradouro') && this.isCepUnico();
  }

  isCepUnico() {
    const { Cep } = this.state;
    const { isForceCepSingle } = this.props;

    return Cep && (Cep.split('-')[1] === '000' || isForceCepSingle);
  }

  isRequiredField(field) {
    const { requireAll, disableAll, prefix } = this.props;

    if (requireAll !== undefined) {
      return requireAll;
    }

    if (disableAll || prefix == 'V') {
      return false;
    }

    return DDados.Campos[field].Obrigatorio;
  }

  render() {
    const { Campos } = DDados;

    const {
      name,
      prefix,
      editavel,
      removeNumber,
      isViewComplementoNumero,
      disableAll,
      disableCep,
      onFocusCep,
      onChange,
      filterCepBySede,
      desabilitaCamposObrigatorios,
      numeroObrigatorio,
      buttons,
    } = this.props;

    const { state, isDisabledField, isRequiredField, cepSede } = this;

    const isView = prefix === 'V';

    return (
      <Fragment>
        <Row>
          <Col sm={3}>
            <Row>
              <Col sm={this.isExterno || isView ? '12' : '9'}>
                <DDadosItem
                  {...Campos.Cep}
                  name={name + '.Cep'}
                  state={state}
                  stateName="Cep"
                  onBlur={this.onChangeCep}
                  isView={isView}
                  Desabilitado={disableAll || disableCep || this.isDisabledField('Cep')}
                  Obrigatorio={isRequiredField('Cep') && !desabilitaCamposObrigatorios}
                  onFocus={onFocusCep}
                />
              </Col>

              {!this.isExterno && !isView && (
                <Col>
                  <DDadosItem
                    {...Campos.EnderecoLookup}
                    name="Cep"
                    state={state}
                    onChange={isView ? undefined : (value) => this.onChangeCep(value)}
                    Desabilitado={disableAll || disableCep}
                    buttons={buttons}
                    lookup={
                      <AddressLookup
                        parameters={[
                          { Nome: 'filterCepBySede', Valor: filterCepBySede },
                          { Nome: 'cepSede', Valor: cepSede },
                        ]}
                      />
                    }
                  />
                </Col>
              )}
            </Row>
          </Col>

          <Col sm="3">
            <DDadosItem
              {...Campos.UF}
              name={name + '.UF'}
              state={state}
              stateName="UF"
              isView={isView}
              Desabilitado={isDisabledField('UF')}
              Obrigatorio={isRequiredField('UF') && !desabilitaCamposObrigatorios}
              onChange={(value) => onChange && onChange({ UF: value })}
            />
          </Col>

          <Col sm="6">
            <DDadosItem
              {...Campos.Cidade}
              name={name + '.Cidade'}
              stateName="Cidade"
              service={api.cidadeSuggestion}
              parameters={state}
              state={state}
              isView={isView}
              Desabilitado={isDisabledField('Cidade')}
              Obrigatorio={isRequiredField('Cidade') && !desabilitaCamposObrigatorios}
              onChange={(value) => onChange && onChange({ Cidade: value })}
              mapItem={(item) => ({
                ...item,
                Exibicao: item.Cidade + ' - ' + item.Uf,
              })}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="3">
            <DDadosItem
              {...Campos.Bairro}
              name={name + '.Bairro'}
              stateName="Bairro"
              service={api.bairroSuggestion}
              parameters={state}
              mapItem={(item) => ({ ...item, Exibicao: item.Bairro })}
              state={state}
              editavel={editavel}
              isView={isView}
              Desabilitado={isDisabledField('Bairro')}
              Obrigatorio={isRequiredField('Bairro') && !desabilitaCamposObrigatorios}
              onChange={(value) => onChange && onChange({ Bairro: value })}
            />
          </Col>

          <Col sm="3">
            <DDadosItem
              {...Campos.Tipo}
              name={name + '.Tipo'}
              stateName="Tipo"
              labelKey="TipoLogradouro"
              itens={state.tipoLogradouro}
              state={state}
              isView={isView}
              Desabilitado={isDisabledField('Tipo')}
              Obrigatorio={isRequiredField('Tipo') && !desabilitaCamposObrigatorios}
              onChange={(value) => onChange && onChange({ Tipo: value.TipoLogradouro })}
            />
          </Col>

          <Col sm="6">
            <DDadosItem
              {...Campos.Logradouro}
              name={name + '.Logradouro'}
              stateName="Logradouro"
              service={api.logradouroSuggestion}
              parameters={state}
              state={state}
              editavel={editavel}
              isView={isView}
              Desabilitado={isDisabledField('Logradouro')}
              Obrigatorio={isRequiredField('Logradouro') && !desabilitaCamposObrigatorios}
              onChange={(value) => onChange && onChange({ Logradouro: value })}
              mapItem={(item) => ({
                ...item,
                Exibicao: item.Logradouro + ' - ' + item.Bairro,
              })}
            />
          </Col>
        </Row>

        {!removeNumber && (
          <Fragment>
            <Row>
              <Col sm="3">
                <DDadosItem
                  name={name + '.Numero'}
                  stateName="Numero"
                  {...Campos.Numero}
                  state={state}
                  isView={isView}
                  Obrigatorio={numeroObrigatorio}
                  Desabilitado={isDisabledField('Numero')}
                  onChange={(value) => onChange && onChange({ Numero: value })}
                />
              </Col>

              {isViewComplementoNumero && (
                <Col sm="3">
                  <DDadosItem
                    name={name + '.ComplementoNumero'}
                    stateName="ComplementoNumero"
                    {...Campos.ComplementoNumero}
                    state={state}
                    isView={isView}
                    Desabilitado={isDisabledField('ComplementoNumero')}
                    onChange={(value) => onChange && onChange({ ComplementoNumero: value })}
                  />
                </Col>
              )}

              <Col sm={isViewComplementoNumero ? '6' : '9'}>
                <DDadosItem
                  name={name + '.Complemento'}
                  stateName="Complemento"
                  {...(this.props.Campos?.Complemento || Campos.Complemento)}
                  state={state}
                  isView={isView}
                  Desabilitado={isDisabledField('Complemento')}
                  onChange={(value) => onChange && onChange({ Complemento: value })}
                />
              </Col>
            </Row>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default connect({
  actions: { addressActions },
  selectors: { addressSelectors },
})(AddressMultiple);
